export default __webpack_public_path__ + "static/media/KZ.T.03.E0810.0bab65af.svg";